import { APIPromise } from "services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { AlertRuleDTO, CreateAlertRuleRequest, UpdateAlertRuleRequest } from "./model/alerts/alert-types";

class AlertRulesApiDefinition extends ApiDefinition {
  constructor() {
    super("/alerts/rules");
  }

  async getAlertRulesForCompany(companyRef: string): APIPromise<AlertRuleDTO[]> {
    return this.get(`company/${companyRef}`);
  }

  async getAlertRule(ruleId: number): APIPromise<AlertRuleDTO> {
    return this.get(`${ruleId}`);
  }

  async createAlertRule(rule: CreateAlertRuleRequest): APIPromise<AlertRuleDTO> {
    return this.post(null, rule);
  }

  async updateAlertRule(rule: UpdateAlertRuleRequest): APIPromise<AlertRuleDTO> {
    return this.put(`${rule.id}`, rule);
  }

  async deleteAlertRule(ruleId: number): APIPromise<void> {
    return this.delete(`${ruleId}`);
  }

  async toggleAlertRule(ruleId: number, enabled: boolean): APIPromise<AlertRuleDTO> {
    return this.patch(`${ruleId}/toggle`, { enabled });
  }
}

const AlertRulesApi = new AlertRulesApiDefinition();
export default AlertRulesApi;
